export const backUrl =
  process.env.NODE_ENV === "production" && navigator.userAgent !== "ReactSnap"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:5001/api";
export const businessUrl = process.env.REACT_APP_BUSINESS_URL;
export const agentManagerUrl =
  process.env.NODE_ENV === "production" && navigator.userAgent !== "ReactSnap"
    ? process.env.REACT_APP_AGENT_MANAGER_URL
    : process.env.REACT_APP_AGENT_MANAGER_URL || "http://localhost:8080";
